import { render, staticRenderFns } from "./QRModal.vue?vue&type=template&id=31135e2a&scoped=true"
import script from "./QRModal.vue?vue&type=script&lang=js"
export * from "./QRModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31135e2a",
  null
  
)

export default component.exports